import axiosInstance from '@/store/axios'
import { rejectError } from '@/store/helper'

export default {
  state: {},
  getters: {},
  mutations: {},
  actions: {
    // eslint-disable-next-line no-unused-vars
    genres ({ commit }, params) {
      return axiosInstance.get('/api/v1/genres', { params })
        .then((result) => result.data.data)
        .catch((error) => rejectError(error))
    },
    // eslint-disable-next-line no-unused-vars
    locations ({ commit }, params) {
      return axiosInstance.get('/api/v1/locations', { params })
        .then((result) => result.data.data)
        .catch((error) => rejectError(error))
    },
    // eslint-disable-next-line no-unused-vars
    templates ({ commit }, params) {
      return axiosInstance.get('/api/v1/templates', { params })
        .then((result) => result.data.data)
        .catch((error) => rejectError(error))
    },
  },
}
